import styled from 'styled-components';

export const H2 = styled.h2`
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15em;
  text-shadow:
    -25px 25px 40px rgba(0, 0, 0, 0.5),
    -10px 10px 0 rgba(255, 255, 255, 0.5),
    -20px 20px 0 rgba(255, 255, 255, 0.2),
    -30px 30px 0 rgba(255, 255, 255, 0.05);
`;
